import { Reload, RequestState } from "@shared/platform-api/requests"
import { FromApiBase } from "./types"

export type FromApi<T, I> = FromApiBase<I> & {
  data: T | undefined
}

export const useApi = <T, I>(res: RequestState<T>, reload: Reload<I>): FromApi<T, I> => {
  if (res.result?.tag === `err`) {
    // eslint-disable-next-line no-console
    console.log(res.result.error)
  }
  return {
    data: res.result?.data,
    loading: res.loading || !res.result,
    apiErrored: res.result?.tag === `err`,
    reload,
  }
}
